import React from 'react';
import { motion } from 'framer-motion';
const testimonials = [{
  id: 1,
  text: 'האיכות מטורפת. העיצוב שובר. אין דברים כאלה בארץ.',
  author: '@alex_urban',
  color: 'bg-magenta',
  rotate: '-rotate-3'
}, {
  id: 2,
  text: 'כל דרופ שלהם זה סולד אאוט ב-5 דקות. שווה כל שקל.',
  author: '@dan_street',
  color: 'bg-acid',
  rotate: 'rotate-2'
}, {
  id: 3,
  text: 'הבגדים היחידים שאני לובש עכשיו. REBEL זה משפחה.',
  author: '@maya_vibes',
  color: 'bg-electric',
  rotate: '-rotate-1'
}];
export function Community() {
  return <section id="קהילה" className="py-24 bg-white relative overflow-hidden" data-id="element-26">
      {/* Background pattern */}
      <div className="absolute inset-0 opacity-5" style={{
      backgroundImage: 'repeating-linear-gradient(45deg, #000 0, #000 2px, transparent 2px, transparent 10px)'
    }} data-id="element-27"></div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-28">
        <h2 className="text-6xl md:text-8xl font-black uppercase tracking-tighter mb-16 text-center" data-id="element-29">
          <span className="bg-black text-white px-6 py-2 inline-block brutal-border" data-id="element-30">
            הקהילה
          </span>
        </h2>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 md:gap-12" data-id="element-31">
          {testimonials.map((t, index) => <motion.div key={t.id} initial={{
          opacity: 0,
          scale: 0.8
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.2
        }} whileHover={{
          scale: 1.05,
          rotate: 0
        }} className={`brutal-card ${t.color} p-8 ${t.rotate} transform transition-transform duration-300 relative`} data-id="element-32">
              {/* Tape effect */}
              <div className="absolute -top-4 left-1/2 -translate-x-1/2 w-24 h-8 bg-white/50 backdrop-blur-sm brutal-border rotate-2" data-id="element-33"></div>

              <p className="text-2xl font-bold mb-6 mt-4 leading-snug text-black" data-id="element-34">
                "{t.text}"
              </p>
              <div className="text-xl font-black font-archivo text-black" dir="ltr" data-id="element-35">
                {t.author}
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}